var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "grid_wrap mt25" }, [
      _c("div", { staticClass: "sub_tit" }, [
        _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.BASIC.INFO")))
      ])
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "create_table" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("tbody", [
        _c("tr", [
          _c("th", [
            _vm._v(_vm._s(_vm.$t("FIELD.LOCALE.RESOURCE.TYPE"))),
            _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
          ]),
          _vm._v(" "),
          _c("td", [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.resType,
                    expression: "resType"
                  }
                ],
                staticClass: "slt_white w100",
                attrs: { disabled: _vm.viewMode },
                on: {
                  change: [
                    function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.resType = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                    _vm.changeResType
                  ]
                }
              },
              [
                _c("option", { attrs: { value: "", selected: "" } }, [
                  _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.OPTION.DETAIL.NAME")))
                ]),
                _vm._v(" "),
                _vm._l(_vm.pResTypes, function(type) {
                  return _c(
                    "option",
                    { key: type.code, domProps: { value: type.code } },
                    [_vm._v(_vm._s(type.codeName))]
                  )
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("th", [
            _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.USE"))),
            _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
          ]),
          _vm._v(" "),
          _c("td", [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.useYn,
                    expression: "useYn"
                  }
                ],
                staticClass: "slt_white w100",
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.useYn = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { value: "Y", selected: "" } }, [
                  _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.YES")))
                ]),
                _vm._v(" "),
                _c("option", { attrs: { value: "N" } }, [
                  _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.NO")))
                ])
              ]
            )
          ])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("th", [
            _vm._v(_vm._s(_vm.$t("FIELD.LOCALE.RESOURCE.ID"))),
            _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
          ]),
          _vm._v(" "),
          _c("td", [
            _c("span", { staticClass: "clearable" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.resId,
                    expression: "resId"
                  },
                  { name: "clearable", rawName: "v-clearable" }
                ],
                ref: "resId",
                staticClass: "text_input w100",
                attrs: {
                  type: "text",
                  disabled: _vm.viewMode,
                  maxlength: "50"
                },
                domProps: { value: _vm.resId },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.resId = $event.target.value
                  }
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("th", [
            _vm._v(_vm._s(_vm.$t("FIELD.LOCALE.RESOURCE.NAME"))),
            _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
          ]),
          _vm._v(" "),
          _c("td", [
            _c("span", { staticClass: "clearable" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.resNm,
                    expression: "resNm"
                  },
                  { name: "clearable", rawName: "v-clearable" }
                ],
                ref: "resNm",
                staticClass: "text_input w100",
                attrs: { type: "text", maxlength: "80" },
                domProps: { value: _vm.resNm },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.resNm = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("i", { staticClass: "clearable_clear" }, [_vm._v("X")])
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "btn_wrap topLine" }),
    _vm._v(" "),
    _c("div", { staticClass: "grid_wrap mt25" }, [
      _c("div", { staticClass: "sub_tit" }, [
        _vm._v(_vm._s(_vm.$t("FIELD.ADMIN.LABEL.SETTING")))
      ]),
      _vm._v(" "),
      this.sysAdmYn == "Y"
        ? _c("div", { staticClass: "btn_wrap" }, [
            _c(
              "a",
              {
                staticClass: "btn_white",
                attrs: { href: "JavaScript:" },
                on: {
                  click: function($event) {
                    return _vm.localeCopy()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.COPY")))]
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("table", { staticClass: "scroll_table" }, [
      _vm._m(1),
      _vm._v(" "),
      _c("thead", [
        _c("th", { attrs: { width: "15%" } }, [
          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.LANGUAGE")))
        ]),
        _vm._v(" "),
        _c("th", { attrs: { width: "*" } }, [
          _vm._v(_vm._s(_vm.$t("FIELD.LOCALE.RESOURCE.NAME")))
        ])
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.localeList, function(locale) {
          return _c(
            "tr",
            {
              key: locale.locale,
              on: {
                change: function($event) {
                  return _vm.changeLocale(locale)
                }
              }
            },
            [
              _c("td", { staticClass: "tC w13_5" }, [
                _vm._v(
                  "[" + _vm._s(locale.locale) + "] " + _vm._s(locale.localeNm)
                )
              ]),
              _vm._v(" "),
              _c("td", [
                _c("span", { staticClass: "clearable" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: locale.labelInfo,
                        expression: "locale.labelInfo"
                      },
                      { name: "clearable", rawName: "v-clearable" }
                    ],
                    staticClass: "text_input w100",
                    attrs: { type: "text", placeholder: "", maxlength: "1300" },
                    domProps: { value: locale.labelInfo },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(locale, "labelInfo", $event.target.value)
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("i", { staticClass: "clearable_clear" }, [_vm._v("X")])
                ])
              ])
            ]
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "btn_wrap_full" }, [
      _c(
        "a",
        {
          staticClass: "btn_white size_full",
          attrs: { href: "JavaScript:", title: "" },
          on: {
            click: function($event) {
              return _vm.goList()
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.LIST")))]
      ),
      _vm._v(" "),
      this.sysAdmYn == "Y"
        ? _c("div", { staticClass: "btn_right" }, [
            _vm.viewMode
              ? _c(
                  "a",
                  {
                    staticClass: "btn_white",
                    attrs: { href: "JavaScript:", title: "" },
                    on: {
                      click: function($event) {
                        return _vm.resDelete()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.DELETE")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn_blue",
                attrs: { href: "JavaScript:", title: "" },
                on: {
                  click: function($event) {
                    return _vm.resSave()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SAVE")))]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn_blue",
                attrs: { href: "JavaScript:" },
                on: {
                  click: function($event) {
                    return _vm.applySystem()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.APPLY.SYSTEM")))]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "13.5%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "15%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9079e696", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9079e696","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/system/resource/ResourceAdminView.vue
// module id = uC19
// module chunks = 0